export function normalizeDigits(value: string) {
 return value.replace(/[۰-۹]/g,c=>String("۰۱۲۳۴۵۶۷۸۹".indexOf(c))).replace(/[٠-٩]/g,c=>String("٠١٢٣٤٥٦٧٨٩".indexOf(c)));
}
export function discountExpiry(preset?: string, customTimestamp?: number, time?: string, now = new Date()) {
 const date = customTimestamp !== undefined && !preset ? new Date(customTimestamp) : new Date(now);
 const days:Record<string,number>={"0":0,"1":1,"2":3,"3":7,"4":14};
 if (preset && preset in days) date.setDate(date.getDate()+days[preset]);
 else if(preset==="5") {const day=date.getDate();date.setDate(1);date.setMonth(date.getMonth()+1);const last=new Date(date.getFullYear(),date.getMonth()+1,0).getDate();date.setDate(Math.min(day,last));}
 else if(customTimestamp===undefined) return undefined;
 const [hour,minute]=(time || "23:59").split(":").map(Number);
 if(!Number.isInteger(hour)||hour<0||hour>23||!Number.isInteger(minute)||minute<0||minute>59)return undefined;
 date.setHours(hour,minute,0,0);
 return Number.isFinite(date.getTime())?date:undefined;
}
export function localDateString(date:Date) {
 return [date.getFullYear(),String(date.getMonth()+1).padStart(2,"0"),String(date.getDate()).padStart(2,"0")].join("-");
}
export function validDiscountCode(value:string) {return /^[A-Za-z0-9]{5,}$/.test(value);}

export function validQuote(quote: {amount:number;smsCount:number}) {
 return Number.isFinite(quote.amount) && quote.amount >= 0 && Number.isInteger(quote.smsCount) && quote.smsCount > 0;
}
